// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { CustomFieldOutput } from 'thehive-sdk';

import './CustomFieldListDetails.scss';

interface CustomFieldListDetailsProps {
    data: CustomFieldOutput;
}

const CustomFieldListDetails = ({
    data: { name = '', displayName = '', description = '' },
}: CustomFieldListDetailsProps): ReactElement => (
    <div className="custom-field-title">
        <p className="custom-field-title__title">{`${name} ${displayName && `/ ${displayName}`}`}</p>
        <p className="custom-field-title__description">{description}</p>
    </div>
);

export default CustomFieldListDetails;
